import React from 'react';
import * as S from './style';
import { BUTTON_PREV, BUTTON_NEXT, BUTTON_COMPLETE } from 'commons/ZimssaString';

export interface Props {
    isPrev?: boolean;
    isActive?: boolean;
    isComplete?: boolean;
    spacing?: number;
    onClickPrev?: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
    onClickNext?: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
}

function MoveButton({ isPrev = false, isActive = false, isComplete = false, spacing, onClickPrev, onClickNext }: Props): React.ReactElement {
    return (
        <S.MoveButtonContainer spacing={spacing}>
            <S.MoveButtonWrapper>
                {isPrev ? <S.BtnPrev backGroundColor={'surface_base'} boarderColor={'secondary'} color={'secondary'} fontStyle={'body2_bold'} children={BUTTON_PREV} onClick={onClickPrev} /> : null}
                <S.BtnNext
                    backGroundColor={isActive ? 'secondary' : 'surface_dark_gray'}
                    color={'surface_base'}
                    fontStyle={'body2_bold'}
                    children={isComplete ? BUTTON_COMPLETE : BUTTON_NEXT}
                    onClick={onClickNext}
                />
            </S.MoveButtonWrapper>
        </S.MoveButtonContainer>
    );
}

export default MoveButton;
